// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ParameterEntryCyclesView } from '../model/parameterEntryCyclesView';
// @ts-ignore
import { ParameterType } from '../model/parameterType';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ParameterEntryCyclesService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get parameter entry cycles by siteId, shopId, emissionPointId, parameterId and entryCycleId.
     * @param idSite ParameterEntryCycles site id
     * @param idShop ParameterEntryCycles shop id
     * @param idTool ParameterEntryCycles tool id
     * @param idEmissionPoint ParameterEntryCycles emission point id
     * @param idParameter ParameterEntryCycles parameter id
     * @param idEntryCycle ParameterEntryCycles entry cycle id
     * @param parameterType The parameter type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public parameterEntryCyclesControllerFind(idSite: number, idShop: number, idTool: number, idEmissionPoint: number, idParameter: number, idEntryCycle: number, parameterType: ParameterType, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ParameterEntryCyclesView>;
    public parameterEntryCyclesControllerFind(idSite: number, idShop: number, idTool: number, idEmissionPoint: number, idParameter: number, idEntryCycle: number, parameterType: ParameterType, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ParameterEntryCyclesView>>;
    public parameterEntryCyclesControllerFind(idSite: number, idShop: number, idTool: number, idEmissionPoint: number, idParameter: number, idEntryCycle: number, parameterType: ParameterType, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ParameterEntryCyclesView>>;
    public parameterEntryCyclesControllerFind(idSite: number, idShop: number, idTool: number, idEmissionPoint: number, idParameter: number, idEntryCycle: number, parameterType: ParameterType, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idSite === null || idSite === undefined) {
            throw new Error('Required parameter idSite was null or undefined when calling parameterEntryCyclesControllerFind.');
        }
        if (idShop === null || idShop === undefined) {
            throw new Error('Required parameter idShop was null or undefined when calling parameterEntryCyclesControllerFind.');
        }
        if (idTool === null || idTool === undefined) {
            throw new Error('Required parameter idTool was null or undefined when calling parameterEntryCyclesControllerFind.');
        }
        if (idEmissionPoint === null || idEmissionPoint === undefined) {
            throw new Error('Required parameter idEmissionPoint was null or undefined when calling parameterEntryCyclesControllerFind.');
        }
        if (idParameter === null || idParameter === undefined) {
            throw new Error('Required parameter idParameter was null or undefined when calling parameterEntryCyclesControllerFind.');
        }
        if (idEntryCycle === null || idEntryCycle === undefined) {
            throw new Error('Required parameter idEntryCycle was null or undefined when calling parameterEntryCyclesControllerFind.');
        }
        if (parameterType === null || parameterType === undefined) {
            throw new Error('Required parameter parameterType was null or undefined when calling parameterEntryCyclesControllerFind.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (idSite !== undefined && idSite !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idSite, 'idSite');
        }
        if (idShop !== undefined && idShop !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idShop, 'idShop');
        }
        if (idTool !== undefined && idTool !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idTool, 'idTool');
        }
        if (idEmissionPoint !== undefined && idEmissionPoint !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idEmissionPoint, 'idEmissionPoint');
        }
        if (idParameter !== undefined && idParameter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idParameter, 'idParameter');
        }
        if (idEntryCycle !== undefined && idEntryCycle !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idEntryCycle, 'idEntryCycle');
        }
        if (parameterType !== undefined && parameterType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>parameterType, 'parameterType');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/parameter-entry-cycles`;
        return this.httpClient.request<ParameterEntryCyclesView>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
